import {
  registerTransformation,
  TransformationType,
} from "../../calculation/Calculation";
import { TransformationTags } from "../../calculation/TransformationTags";
import { pushToMessageLog } from "../../exploration/Exploration";
import { ExplorationStatus } from "../../exploration/ExplorationStatus";
import { hasFlag } from "../../Flags";
import {
  EXPLORATION_INITIAL_STATE,
  PlayerContextState,
} from "../../PlayerContext";
import { addContextListener } from "../../PlayerContextListeners";
import {
  clearTemporaryEffect,
  grantTemporaryEffect,
  hasTemporaryEffect,
} from "../../timetick/TemporaryEffects";
import { getSecondsPlayed } from "../../timetick/TotalTimePlayed";
import { CombatSpellBase } from "../CombatSpellBase";

class Getaway extends CombatSpellBase {
  getSpellName(): string {
    return "Getaway";
  }

  isVisible(state: PlayerContextState): boolean {
    return super.isVisible(state) && hasFlag(state, "exploration_unlocked");
  }

  getBaseCooldown(): number {
    return 1.0;
  }

  getDisplayDescription(): string {
    return "Create an illusion of yourself to trick the enemy.";
  }

  getDisplayEffect(): string {
    return "Immediately exit combat and explore again much quicker.";
  }

  getManaCost(): number {
    return 320;
  }

  getSchoolLevelRequirements(): Record<string, number> {
    return {
      Illusion: 6,
    };
  }

  doSpellAction(state: PlayerContextState): PlayerContextState {
    if (!state.exploration) {
      state.exploration = EXPLORATION_INITIAL_STATE;
    }
    state = grantTemporaryEffect(this.getId(), "Getaway", 3, {
      mode: "replace",
    })(state);
    state.exploration.explorationStatus = ExplorationStatus.Exploring;
    state.exploration.explorationStartTime = getSecondsPlayed(state);
    pushToMessageLog(
      state,
      "You have cast Getaway and ran away from the enemy!",
    );
    return state;
  }

  isCastingRecommended(state: PlayerContextState): boolean {
    return true;
  }

  getEstimatedMinAutocastDelay(state: PlayerContextState): number {
    return 0;
  }
}

const getaway = new Getaway();

registerTransformation(
  [[TransformationTags.ExplorationDelay]],
  "GetawaySpeedup",
  TransformationType.Multiplier,
  (state, params) => (hasTemporaryEffect(state, getaway.getId()) ? 0.1 : 1.0),
);

addContextListener(
  "GetawayBuffCleaning",
  (newState) => {
    if (newState.exploration.explorationStatus == ExplorationStatus.Combat) {
      return clearTemporaryEffect(getaway.getId());
    }
  },
  (state) => state.exploration.explorationStatus,
);

export default getaway;
